export default "__VITE_ASSET__ede9c7fa__"